
<div class="cnt-column-centered popup-body">

    <div [height]="20"></div>
    <div class="p2Font b1Color txt" i18n>{{ 'IF_YOU_QUIT_NOW' | translate }}</div>
    <div [height]="20"></div>


    <div [height]="20"></div>

    <div class="cnt-row-centered">
        <simple-btn [horizontalPadding]="32"
                [text]="dontQuitText | translate"
                [textCls]="'large-btn-text'"
                [height]="40"
                [cornerRadius]="50"
                data-testid="notQuitBtn"
                (click)="handleDontQuit()"
                [backgroundFillCls]="'transparent-background'"
                [hoverFillCls]="'g4Background'"
                [borderWidth]=2
                [borderColorCls]="'g4Border'"
                [hoverBorderColorCls]="'g4Border'"
                [textColorCls]="'g4Color'"
                [hoverTextColorCls]="'white-color'">
        </simple-btn>

        <div [width]="10"></div>

        <simple-btn [horizontalPadding]="32"
                [text]="quitText | translate"
                [backgroundFillCls]="'o2Background'"
                [hoverFillCls]="'o1Background'"
                [boxShadowCls]="'primary-shadow'"
                [textCls]="'large-btn-text'"
                [height]="40"
                [cornerRadius]="50"
                data-testid="quitBtn"
                (click)="handleQuit()">
        </simple-btn>
    </div>

</div>
